export const environment = {
    development: true,
    VERSION: "0.0.101",
    API_DEFINITION_URL: 'https://spriced.nrp.simadvisory.com/api/v1/definition',
    API_DATA_URL: 'https://spriced.nrp.simadvisory.com/api/v1/data-api',
    API_FLINK_URL:'https://spriced.nrp.simadvisory.com/api/v1/flink/platform',
    URL: 'https://excel-addin.spriced.nrp.simadvisory.com',
    AUTH_URL: 'https://auth.simadvisory.com/auth',
    CLIENT: "PROD_SPRICED_NRP_Client",
    REALMS: "PROD_SPRICED_NRP",
    PAGESIZE: 5000,
    PUBLISHRECORD: 2500,
    TOTALELEMENTS: 15000,
    VALIDATIONPOPUPLENGTH: 10000,
    RECORD_LIMIT: 50,
    SERVER_PROCESSING_RECORDS_PER_MINUTE: 900,
    IDP_HINT: 'saml_spriced_prod',
    appUrl:"https://excel-addin.nrp.uat.simadvisory.com",
    NX_TML_URL: "https://spriced.nrp.simadvisory.com/api/v1/tml",
    NX_EXCEL_SERVICE_URL: "https://spriced.nrp.simadvisory.com/api/v1/excel_service/write-csv"
};
